import styled from "styled-components"
export const PreviewPageWrapper = styled.div`
  position: relative;
  @media screen and (max-width: 1000px) {
    /* display:none; */
    padding: 1.714285rem;
    margin-top: 6.714285rem;
  }
`
export const PreviewPageContainer = styled.div`
//   width: 77rem;
  margin: 0 auto;
  padding-top: 140px;
  height: 720px;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    width: 100%;
    margin: 0;
    height: auto;
    // width: 20.428571rem;
    margin: 0 auto;
  }
`
export const PreviewPageInfo = styled.div`
  width: 100%;
  text-align: center;
  @media screen and (max-width: 1000px) {
    width: 100%;
    margin-right: 0;
  }
`

export const InfoText = styled.div`
  h1 {
    font-size: 58px;
    margin-bottom: 10px;
    font-weight: 500;
    @media screen and (max-width: 1000px) {
      font-size: 30px;
      text-align: center;
      margin-block-start: 0em;
      margin-block-end: 1.8rem;
    }
    // span {
    //   color: #e52b2b;
    // }
  }
  span.intro {
    display: block;
    // width: 28.125rem;
    line-height: 1.4rem;
    margin: 10px auto 30px;
    font-size: 20px;
    @media screen and (max-width: 1000px) {
      width: 80%;
      margin: 0 auto;
      text-align: center;
             font-size: 20px;
        line-height: 30px;
    }
  }
`

export const InfoContacts = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
justify-content: center;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    width: 100%;
    text-align: center;
    margin-top: 0.5rem;

    a {
      width: 100%;
      button {
        margin: 20px auto;
                width: 100%;
                height: 51px;
      }
    }
  }
`

export const Telephone = styled.div`
border-radius: 5px;
    background: rgba(255,255, 255, 0.3);
    padding: 16px;
    height: 51px;
    box-sizing: border-box;
    display: flex;
    margin-left: 10px;
    
  img {
    width: 1.029375rem;
    height: 1.029375rem;
    margin-right: 0.798125rem;
  }
  a {
    display: flex;
    align-items: center;
        justify-content: center;
        width: 100%;
  }
  @media screen and (max-width: 1000px) {
    margin: 0 auto;
    width: 100%;
    // border-bottom: 0.16rem solid #ffffff;
  }
`
export const Trust = styled.div`
  img {
  //  width: 490px;
    margin-top: 70px;
    @media screen and (max-width: 1000px) {
      width: 100%;
      margin-top: -1.2rem;
    }
  }
`

